module.exports = __webpack_public_path__ + "img/chevron-right.d1a44e71.svg";